var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v("Выход из приложения выполнен")]),_c('v-btn',{attrs:{"rounded":"","large":""},on:{"click":_vm.Login}},[_vm._v("Войти")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }